export default "__VITE_ASSET__Ocbz$25d__"